export default __webpack_public_path__ + "static/media/orange-juice-menu-bg.a30f2051.png";